import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=77b07766&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./page.scss?vue&type=style&index=0&id=77b07766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b07766",
  null
  
)

export default component.exports